<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      dark
      src="@/assets/img/bgDrawer.jpg"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img src="@/assets/img/xhlogo.png" alt="Logo" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title">星寰科技</v-list-item-title>
            <v-list-item-subtitle>UniversalStar</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item
          v-for="([icon, text, link], i) in items"
          :key="i"
          link
          @click="$vuetify.goTo(link)"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
              text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      class="px-15"
      :class="{ expand: flat }"
    >
      

      <v-toolbar-title>
        <v-img src="@/assets/img/xhkjLogo.png" max-width="140px" />
      </v-toolbar-title>
      <v-spacer />
       
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mr-4"
        v-if="isXs"
      />
      
      <div v-else>
        <v-btn text @click="$vuetify.goTo('#home')">
          <span class="mr-2">首页</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#introduce')">
          <span class="mr-2">公司介绍</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#product')">
          <span class="mr-2">公司产品</span>
        </v-btn>
        <!-- <v-btn text @click="$vuetify.goTo('#partner')">
          <span class="mr-2">合作伙伴</span>
        </v-btn> -->
        <v-btn rounded outlined text @click="$vuetify.goTo('#contact')">
          <span class="mr-2">联系我们</span>
        </v-btn>
      </div>
      <span  class="menu" >
        <button @click="drawer = !drawer">
          <img class="menuImg" src="@/assets/img/menu3.png" />
        </button>
      </span>
    </v-app-bar>
   
  </div>
</template>

<style scoped>
  .v-application .px-15 {
    padding-right: 20px !important;
    padding-left: 20px !important;
}
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}
.menu {
  display: none;
}
@media (max-width: 768px) {
  .menu {
    /* width: 28px; */
    display: block; /* 或者 inline-block, 根据需要 */
  padding-top:3px    
  }
  .menuImg{
    width: 28px;
  }
  .v-application .px-15 {
    padding-right: 20px !important;
    padding-left: 20px !important;
}
}
</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    isClick: false,
    items: [
      ["mdi-home-outline", "首页", "#home"],
      ["mdi-information-outline", "公司介绍", "#introduce"],
      ["mdi-currency-usd", "公司项目", "#product"],
      // ["mdi-download-box-outline", "合作伙伴", "#partner"],
      ["mdi-email-outline", "联系我们", "#contact"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
    isClick(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
